import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { DiversityVariant, DiversityVariantPostData } from '../model/models'

export class DiversityVariantAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getDiversityVariants = this.getDiversityVariants.bind(this)
    this.saveDiversityVariant = this.saveDiversityVariant.bind(this)
  }

  public getDiversityVariants(): Promise<DiversityVariant[]> {
    const endpoint = `/diversity-variants/`
    return this.get<DiversityVariant[]>(endpoint)
      .then((response: AxiosResponse<DiversityVariant[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public saveDiversityVariant(diversityVariants: DiversityVariantPostData[]): Promise<number> {
    const endpoint = `/diversity-variants/`
    return this.post(endpoint, diversityVariants)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }
}

export const diversityVariantAPI = new DiversityVariantAPI(httpConfig)
